import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chip-editor" }
const _hoisted_2 = { class: "chip-editor-h" }
const _hoisted_3 = { class: "chip-editor-count" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.label), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modelValue.length), 1)
    ]),
    _createElementVNode("form", {
      class: "chip-editor-add",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.add()), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
        placeholder: _ctx.placeholder
      }, null, 8, _hoisted_4), [
        [_vModelText, _ctx.input]
      ]),
      _createElementVNode("button", {
        class: "btn",
        "aria-label": 'Add to ' + _ctx.label
      }, [
        _createVNode(_component_svg_icon, { icon: "plus" })
      ], 8, _hoisted_5)
    ], 32),
    (_ctx.modelValue.length)
      ? (_openBlock(), _createBlock(_component_draggable, {
          key: 0,
          list: _ctx.modelValue,
          class: "tag-chips chip-editor-chips",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', [ ..._ctx.modelValue ])))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: item + i,
                class: "tag-chip"
              }, [
                _createTextVNode(_toDisplayString(item) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "tag-chip-x",
                  "aria-label": 'Remove ' + item,
                  title: "Remove",
                  onClick: ($event: any) => (_ctx.remove(i))
                }, [
                  _createVNode(_component_svg_icon, { icon: "x" })
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["list"]))
      : _createCommentVNode("", true)
  ]))
}